import { render, staticRenderFns } from "./CouponsRequests.vue?vue&type=template&id=078a6eb7&"
import script from "./CouponsRequests.vue?vue&type=script&lang=ts&"
export * from "./CouponsRequests.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports